import type { CatalogueEntry } from "../types";
import imageLight from "../images/g-naf.light.webp";
import imageDark from "../images/g-naf.dark.webp";

export const entry: CatalogueEntry = {
  slug: "g-naf",
  displayName: `G-NAF`,
  datasetProductCode: `G-NAF`,
  subtitle: `Australia's Authoritative Geocoded Address Repository`,
  shortDescription: `G-NAF (Geocoded National Address File) is a trusted index of Australian address information. It contains the state, suburb, street, number and coordinate reference (or 'geocode') for street addresses in Australia. G-NAF does not contain any personal information or details relating to an individual or business.

G-NAF uses existing and recognised address sources (referred to as contributors) from the state and territory government land records and Commonwealth government agencies. The Mesh Block data is sourced from the Australian Bureau of Statistics (ABS) and is part of their Australian Statistical Geography Standard (ASGS). A rigorous process is used that involves textual address comparison, matching and geospatial validation to provide both national consistency and national coverage.`,
  metadata: {
    dateAdded: 1079308800000,
    dataType: ["Points"],
    theme: `Address`,
    totalFeatureCount: 15530436,
    updateFrequency: `Quarterly`,
    license: `Modified CC BY 4.0`,
    licenseLink: `https://data.gov.au/data/dataset/geocoded-national-address-file-g-naf/resource/09f74802-08b1-4214-a6ea-3591b2753d30`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  latestReleaseReportLink: `https://docs.geoscape.com.au/projects/gnaf_release/en/stable/index.html`,
  productDescriptionLink: `https://docs.geoscape.com.au/projects/gnaf_desc/en/stable/index.html`,
  imageLight,
  imageDark,
  searchTags: `G-NAF GNAF Accuracy Address Data Address File Address Verification Addresses CRM Data Enrichment Emergency Services Geocoding Geolocation Location Location Intelligence`,
  detail: () => import("../details/g-naf").then((m) => m.detail),
};

export default entry;
